import React, { useState, useRef } from "react";
import * as dayjs from "dayjs";
import { Button } from "@material-ui/core";
import { ReactRender } from "@/components/ReactRender";
import { useTranslation } from "@/langs/useTranslation";
import {
  getCMSResourceList
} from "@/apis/apiCollection";
import DataTable from "@/components/DataTable";
import { formatSecondsToTime } from "@/helpers/utils";
import { IconPreview } from "@/components/Icon";
import { downloadFileLink } from "@/apis/announcementApi";
import MediaShow from "@/containers/CMS/MediaShow";
export const CMSContentDatatable = React.forwardRef(
  (
    {
      getSearchParams,
      children,
      onLoaded,
      onDraw,
      selectedIds=[],
      single,
      selectedDisable=true
    },
    ref
  ) => {
    const { t } = useTranslation();
    const [previewOpen, setPreviewOpen] = useState(false)
    const [mediaSrc, setMediaSrc] = useState("")
    const [mediaType, setMediaType] = useState("")

    const handlePreview = async (s3Path, type) => {
      const { download_link: src } = await downloadFileLink(s3Path)
      setPreviewOpen(true)
      setMediaSrc(src)
      setMediaType((type || "").split('/')[0])
    }

    const columns = [
      {
        data: "id",
        type: "checkbox",
      },
      {
        data: "name",
        title: t({ defaultMessage: "资源名称" }),
        searchable: true,
        orderable: false
      },
      {
        data: "s3Path",
        title: "",
        orderable: false,
        createdCell: (td, data, row) => {
          ReactRender(
            <IconPreview size={16} onClick={() => handlePreview(data, row.mimeType)} />
            ,
            td
          );
        }
      },
      {
        data: "mimeType",
        title: t({ defaultMessage: "类型" }),
        orderable: false,
        render: data => {
          if (data.indexOf("/") >= 0) return data.split("/")[1];
          return data
        },
      },
      {
        data: "width",
        title: t({ defaultMessage: "尺寸" }),
        orderable: false,
        render: (data, _, row) => {
          return `${row.width}*${row.height}`
        },
      },
      {
        data: "size",
        title: t({ defaultMessage: "大小" }),
        orderable: false,
        render: (data) => {
          return `${(data / 1048576).toFixed(2)} MB`
        },
      },
      {
        data: "duration",
        title: t({ defaultMessage: "时长" }),
        orderable: false,
        render: (data) => {
          if (data) return formatSecondsToTime(data)
          return ""
        },
      },
      {
        data: "status",
        title: t({ defaultMessage: "状态" }),
        orderable: false,
        createdCell: (td, data, row) => {
          let Compo
          if (data === 1 || data === 2) Compo = <div style={{color: "#5258DD"}}>{t({defaultMessage: "审核中"})}</div>
          if (data === 3) Compo = <div style={{color: "#00B42A"}}>{t({defaultMessage: "审核通过"})}</div>
          if (data === 4) Compo = <div style={{color: "#F53F3F"}}>{t({defaultMessage: "审核失败"})}</div>
          ReactRender(
            Compo,
            td
          );
        }
      },
    ];


    const ajax = (data, callback) => {
      return getCMSResourceList({
        ...data,
        ...getSearchParams()
      }).then(res => {
        // todo 暂时在这里过滤已选内容，后面做成已选中
        callback({
          // data: res.contentResources.filter(v => !(selectedIds.indexOf(v.id)>=0)),
          data: res.contentResources,
          // draw: data.draw,
          recordsFiltered: res.total,
          recordsTotal: res.total
        });
      });
    };

    const handleSelected = () => {
      ref.current.setSelected(selectedIds, true)
      if (selectedDisable) ref.current.setDisabled(selectedIds, true)
    }

    return (
      <>
        <DataTable
          ref={ref}
          ordering
          columns={columns}
          ajax={ajax}
          scrollable
          showCheckAll={false}
          autoLoad
          onLoaded={handleSelected}
          singleCheck={single}
          // onDraw={handleSelected}
        >
          {children}
        </DataTable>
        <MediaShow
          type={mediaType}
          src={mediaSrc}
          open={previewOpen}
          onClose={() => setPreviewOpen(false)}
        />
      </>
    );
  }
);